import { Link } from "react-router-dom";
import { iconFor } from "@/lib/contentIcons";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/common/PageHero";
import HelpCTA from "@/components/common/HelpCTA";
import { Reveal } from "@/components/common/Reveal";
import { useServices, useSite } from "@/context/SiteDataContext";

const EXTRA = ["Installation", "Application Support", "After-Sales Service"];

export default function Services() {
  const SERVICES = useServices();
  const SITE = useSite();
  return (
    <>
      <Seo routeKey="services" title="Services" description="Technical and scientific solutions, preventive maintenance and flexible equipment rental from Athena Scientific." canonical={`https://${SITE.website}/services`} />
      <PageHero eyebrow="Services" title="Support that empowers your laboratory" description="From consultation and installation to maintenance and rental — our support is designed around your objectives, not a checklist." crumbs={[{ label: "Services" }]} />

      <section className="container-x py-16 md:py-24">
        <div className="grid md:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = iconFor(s.icon);
            return (
              <Reveal key={s.slug} delay={i * 0.08}>
                <Link to={`/services/${s.slug}`} data-testid={`service-card-${s.slug}`} className="group flex flex-col h-full p-8 rounded-lg border border-border bg-white hover:border-aqua/40 hover:shadow-[0_12px_32px_rgba(0,0,0,0.06)] transition-all">
                  <div className="w-12 h-12 rounded-md bg-ink text-white flex items-center justify-center group-hover:bg-aqua transition-colors"><Icon className="w-6 h-6" strokeWidth={1.8} /></div>
                  <h2 className="mt-6 text-xl font-bold text-ink">{s.name}</h2>
                  <p className="mt-2 text-greyish text-sm flex-1">{s.short}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-aqua group-hover:gap-3 transition-all">Learn more <ArrowRight className="w-4 h-4" /></span>
                </Link>
              </Reveal>
            );
          })}
        </div>

        <Reveal>
          <div className="mt-12 flex flex-wrap gap-3">
            {EXTRA.map((e) => (
              <span key={e} className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-[#f6f8f9] border border-border text-sm font-semibold text-greyish">
                <span className="w-1.5 h-1.5 rounded-full bg-aqua" /> {e}
              </span>
            ))}
          </div>
        </Reveal>
      </section>

      <HelpCTA />
    </>
  );
}
